<template>
    <div>
        <NavBar></NavBar>
        <div class="row">
            <MarketWatch class="col-md-4 d-none d-md-block"></MarketWatch>
            <div class="col-md-8 d-flex align-items-center justify-content-center vh-100" v-if="$store.state.openOrders.length == 0 && $store.state.executedOrders.length == 0">
                <div class="empty-state">
                    <div class="empty-icon">
                        <i class="bi bi-journal-text"></i>
                    </div>
                    <h5>No Orders Today</h5>
                    <p>Your orders will appear here once you place them</p>
                </div>
            </div>
            <div class="col-md-8" v-else>
                <div class="page-container">
                    <!-- Open Orders Section -->
                    <div class="orders-section" v-if="$store.state.openOrders.length > 0">
                        <div class="section-header">
                            <div class="section-title">
                                <i class="bi bi-clock-history"></i>
                                <h5>Open Orders</h5>
                                <span class="item-count">{{ $store.state.openOrders.length }}</span>
                            </div>
                        </div>

                        <!-- Desktop Table -->
                        <div class="data-table d-none d-md-block">
                            <div class="table-header">
                                <div class="col-check"><input class="form-check-input" type="checkbox" v-model="checkAllFlag" @change="checkAll()"></div>
                                <div class="col-time">Time</div>
                                <div class="col-type">Type</div>
                                <div class="col-instrument">Instrument</div>
                                <div class="col-product">Product</div>
                                <div class="col-qty">Qty</div>
                                <div class="col-ltp">LTP</div>
                                <div class="col-price">Price</div>
                                <div class="col-status">Status</div>
                                <div class="col-action"></div>
                            </div>
                            <div class="table-row" v-for="(item, index) in $store.state.openOrders" :key="item.id">
                                <div class="col-check"><input class="form-check-input" type="checkbox" v-model="item.check" @change="exitButton()"></div>
                                <div class="col-time">{{ getTime(item.modifiedTimestamp) }}</div>
                                <div class="col-type">
                                    <span class="type-badge" :class="item.orderType === 'BUY' ? 'buy' : 'sell'">{{ item.orderType }}</span>
                                </div>
                                <div class="col-instrument"><span class="instrument-name">{{ item.instrumentName }}</span></div>
                                <div class="col-product"><span class="product-badge">{{ item.duration }}</span></div>
                                <div class="col-qty">{{ item.qty }}</div>
                                <div class="col-ltp">{{ $store.state.ticker[item.instrumentToken] }}</div>
                                <div class="col-price">{{ item.price }}</div>
                                <div class="col-status"><span class="status-badge pending">{{ item.status }}</span></div>
                                <div class="col-action">
                                    <button class="btn-action modify" @click="modify(index)" title="Modify">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="table-footer" v-if="exitButtonVisible">
                                <button type="button" class="btn-cancel-all" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    <i class="bi bi-x-circle"></i>
                                    Cancel {{ exitButtonCount }} {{ exitButtonCount > 1 ? 'orders' : 'order' }}
                                </button>
                            </div>
                        </div>

                        <!-- Mobile Cards -->
                        <div class="d-block d-md-none mobile-container">
                            <div class="order-card" v-for="(item, index) in $store.state.openOrders" :key="item.id">
                                <div class="card-header-row">
                                    <div class="header-left">
                                        <span class="instrument-name">{{ item.instrumentName }}</span>
                                        <span class="type-badge" :class="item.orderType === 'BUY' ? 'buy' : 'sell'">{{ item.orderType }}</span>
                                    </div>
                                    <input class="form-check-input" type="checkbox" v-model="item.check" @change="exitButton()">
                                </div>
                                <div class="card-details">
                                    <div class="detail-item">
                                        <span class="detail-label">Product</span>
                                        <span class="detail-value">{{ item.duration }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Qty</span>
                                        <span class="detail-value">{{ item.qty }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Price</span>
                                        <span class="detail-value">{{ item.price }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">LTP</span>
                                        <span class="detail-value">{{ $store.state.ticker[item.instrumentToken] }}</span>
                                    </div>
                                </div>
                                <div class="card-footer-row">
                                    <div class="footer-left">
                                        <span class="status-badge pending">{{ item.status }}</span>
                                        <span class="order-time">{{ getTime(item.modifiedTimestamp) }}</span>
                                    </div>
                                    <button class="btn-card modify" @click="modify(index)">Modify</button>
                                </div>
                            </div>
                            <button type="button" v-if="exitButtonVisible" class="btn-cancel-mobile" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                <i class="bi bi-x-circle"></i>
                                Cancel {{ exitButtonCount }} {{ exitButtonCount > 1 ? 'orders' : 'order' }}
                            </button>
                        </div>
                    </div>

                    <!-- Executed Orders Section -->
                    <div class="orders-section" v-if="$store.state.executedOrders.length > 0">
                        <div class="section-header">
                            <div class="section-title">
                                <i class="bi bi-check2-circle"></i>
                                <h5>Executed Orders</h5>
                                <span class="item-count">{{ $store.state.executedOrders.length }}</span>
                            </div>
                        </div>

                        <!-- Desktop Table -->
                        <div class="data-table d-none d-md-block">
                            <div class="table-header executed">
                                <div class="col-time">Time</div>
                                <div class="col-type">Type</div>
                                <div class="col-instrument">Instrument</div>
                                <div class="col-product">Product</div>
                                <div class="col-qty">Qty</div>
                                <div class="col-ltp">LTP</div>
                                <div class="col-price">Price</div>
                                <div class="col-status">Status</div>
                            </div>
                            <div class="table-row" v-for="item in $store.state.executedOrders" :key="item.id">
                                <div class="col-time">{{ getTime(item.modifiedTimestamp) }}</div>
                                <div class="col-type">
                                    <span class="type-badge" :class="item.orderType === 'BUY' ? 'buy' : 'sell'">{{ item.orderType }}</span>
                                </div>
                                <div class="col-instrument"><span class="instrument-name">{{ item.instrumentName }}</span></div>
                                <div class="col-product"><span class="product-badge">{{ item.duration }}</span></div>
                                <div class="col-qty">{{ item.qty }}</div>
                                <div class="col-ltp">{{ $store.state.ticker[item.instrumentToken] }}</div>
                                <div class="col-price">{{ item.price }}</div>
                                <div class="col-status">
                                    <span class="status-badge" :class="{'complete': item.status === 'COMPLETE', 'cancelled': item.status === 'CANCELLED'}">{{ item.status }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Mobile Cards -->
                        <div class="d-block d-md-none mobile-container">
                            <div class="order-card" v-for="item in $store.state.executedOrders" :key="item.id">
                                <div class="card-header-row">
                                    <div class="header-left">
                                        <span class="instrument-name">{{ item.instrumentName }}</span>
                                        <span class="type-badge" :class="item.orderType === 'BUY' ? 'buy' : 'sell'">{{ item.orderType }}</span>
                                    </div>
                                </div>
                                <div class="card-details">
                                    <div class="detail-item">
                                        <span class="detail-label">Product</span>
                                        <span class="detail-value">{{ item.duration }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Qty</span>
                                        <span class="detail-value">{{ item.qty }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">Price</span>
                                        <span class="detail-value">{{ item.price }}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="detail-label">LTP</span>
                                        <span class="detail-value">{{ $store.state.ticker[item.instrumentToken] }}</span>
                                    </div>
                                </div>
                                <div class="card-footer-row">
                                    <div class="footer-left">
                                        <span class="status-badge" :class="{'complete': item.status === 'COMPLETE', 'cancelled': item.status === 'CANCELLED'}">{{ item.status }}</span>
                                        <span class="order-time">{{ getTime(item.modifiedTimestamp) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Cancel Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancel {{ exitButtonCount }} {{ exitButtonCount > 1 ? 'Orders' : 'Order' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p class="modal-subtitle">The following orders will be cancelled:</p>
                        <div class="cancel-list">
                            <div class="cancel-item" v-for="(item, index) in $store.state.openOrders" :key="index" v-if="item.check">
                                <i class="bi bi-x-circle"></i>
                                <span>{{ item.instrumentName }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Keep Orders</button>
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="cancelOrders()">Confirm Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/main/NavBar.vue'
import MarketWatch from '@/components/marketwatch/MarketWatch'
import { getOrders, cancelOrders } from '@/service/restService'
export default {
  name: 'Order',
  components: {
    NavBar,
    MarketWatch
  },
  data () {
    return {
      checkAllFlag: false,
      exitButtonVisible: false,
      exitButtonCount: 0
    }
  },
  methods: {
    getOrders: function () {
      if (this.$store.state.orderFirstTimeFlag) {
        getOrders().then((response) => {
          this.$store.commit('updateExecutedOrder', response.data.executed)
          this.$store.commit('updateOpenOrder', response.data.open)
          this.$store.commit('disableOrderFirstTime')
        }).catch((error) => {
          this.$store.commit('addToast', {
            title: 'Failure!',
            type: 'error',
            message: error.response.data.message[0]
          })
        })
      }
    },
    checkAll: function () {
      for (var i = 0; i < this.$store.state.openOrders.length; i++) {
        var pos = this.$store.state.openOrders[i]
        pos.check = this.checkAllFlag
      }
      this.exitButton()
    },
    exitButton: function () {
      var exitButtonFlag = false
      this.exitButtonCount = 0
      for (var i = 0; i < this.$store.state.openOrders.length; i++) {
        var pos = this.$store.state.openOrders[i]
        if (pos.check) {
          exitButtonFlag = true
          this.exitButtonCount = this.exitButtonCount + 1
        }
      }
      if (!exitButtonFlag) {
        this.checkAllFlag = false
      }
      this.exitButtonVisible = exitButtonFlag
    },
    cancelOrders: function () {
      var buySellObjectArr = []
      for (var i = 0; i < this.$store.state.openOrders.length; i++) {
        var pos = this.$store.state.openOrders[i]
        if (pos.check) {
          buySellObjectArr.push(pos.id)
        }
        pos.check = false
      }
      cancelOrders(buySellObjectArr).then((response) => {
        this.exitButtonVisible = false
        this.getUserView()
        for (var i = 0; i < response.data.length; i++) {
          var res = response.data[0]
          if (res.status === 'SUCCESS') {
            this.$store.commit('removeMyOpenOrder', res.id)
            this.$store.commit('addToast', {
              title: 'Cancelled!',
              type: 'success',
              message: 'Order Cancelled Successfully for ' + res.instrumentName
            })
          }
          if (res.status === 'FAILED') {
            this.$store.commit('addToast', {
              title: 'Failure!',
              type: 'error',
              message: res.msg
            })
          }
        }
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    modify: function (id) {
      var order = this.$store.state.openOrders[id]
      var type = order.orderType
      var mw = { }
      mw.instrumentToken = order.instrumentToken
      mw.displayName = order.instrumentName
      mw.qty = Math.abs(order.qty)
      mw.duration = order.duration
      mw.lotSize = order.lotSize
      mw.orderType = order.executionType
      mw.modifyId = order.id
      if (order.executionType === 'SL') {
        mw.triggerPrice = order.price
      } else {
        mw.price = order.price
      }
      this.$store.commit('setBuySell', {'type': type, 'mw': mw})
    }
  },
  created () {
    this.getOrders()
    this.exitButton()
  }
}
</script>

<style scoped>
/* Page Container */
.page-container {
  padding: 20px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--bs-tertiary-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.empty-icon i {
  font-size: 36px;
  color: var(--bs-secondary-color);
}

.empty-state h5 {
  color: var(--bs-body-color);
  margin-bottom: 8px;
}

.empty-state p {
  color: var(--bs-secondary-color);
  margin: 0;
}

/* Section Header */
.orders-section {
  margin-bottom: 24px;
}

.section-header {
  margin-bottom: 16px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title i {
  font-size: 20px;
  color: var(--bs-primary);
}

.section-title h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.item-count {
  background: var(--bs-tertiary-bg);
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  color: var(--bs-secondary-color);
}

/* Desktop Table */
.data-table {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: 40px 70px 60px 2fr 70px 50px 70px 70px 80px 50px;
  padding: 12px 16px;
  background: var(--bs-tertiary-bg);
  font-size: 11px;
  font-weight: 600;
  color: var(--bs-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  align-items: center;
}

.table-header.executed {
  grid-template-columns: 70px 60px 2fr 70px 50px 70px 70px 80px;
}

.table-row {
  display: grid;
  grid-template-columns: 40px 70px 60px 2fr 70px 50px 70px 70px 80px 50px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--bs-border-color);
  align-items: center;
  transition: background-color 0.2s;
  font-size: 13px;
}

.orders-section:last-child .table-row {
  grid-template-columns: 70px 60px 2fr 70px 50px 70px 70px 80px;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background: var(--bs-tertiary-bg);
}

.table-row .instrument-name {
  font-weight: 600;
  color: var(--bs-body-color);
}

.type-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 4px;
  text-transform: uppercase;
}

.type-badge.buy {
  background: rgba(13, 110, 253, 0.15);
  color: #0d6efd;
}

.type-badge.sell {
  background: rgba(239, 1, 7, 0.15);
  color: #EF0107;
}

.product-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  background: var(--bs-tertiary-bg);
  color: var(--bs-secondary-color);
}

.status-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
}

.status-badge.pending {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
}

.status-badge.complete {
  background: rgba(11, 218, 81, 0.15);
  color: #0BDA51;
}

.status-badge.cancelled {
  background: rgba(239, 1, 7, 0.15);
  color: #EF0107;
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  opacity: 0;
}

.table-row:hover .btn-action {
  opacity: 1;
}

.btn-action.modify {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.btn-action.modify:hover {
  background: #0d6efd;
  color: white;
}

.table-footer {
  padding: 12px 16px;
  background: var(--bs-tertiary-bg);
}

.btn-cancel-all {
  padding: 10px 20px;
  background: #EF0107;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-cancel-all:hover {
  background: #c70000;
}

/* Mobile Cards */
.mobile-container {
  padding: 0;
}

.order-card {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-header-row .instrument-name {
  font-weight: 600;
  font-size: 15px;
  color: var(--bs-body-color);
}

.card-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 12px 0;
  border-top: 1px solid var(--bs-border-color);
  border-bottom: 1px solid var(--bs-border-color);
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-label {
  font-size: 11px;
  color: var(--bs-secondary-color);
}

.detail-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.card-footer-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.order-time {
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.btn-card {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-card.modify {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.btn-cancel-mobile {
  width: 100%;
  padding: 14px;
  background: #EF0107;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

/* Modal styling */
.modal-content {
  background-color: var(--bs-body-bg);
  border: none;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 20px 24px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
}

.modal-body {
  padding: 24px;
}

.modal-subtitle {
  font-size: 14px;
  color: var(--bs-secondary-color);
  margin-bottom: 16px;
}

.cancel-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cancel-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: var(--bs-tertiary-bg);
  border-radius: 8px;
}

.cancel-item i {
  color: #EF0107;
}

.cancel-item span {
  font-weight: 500;
}

.modal-footer {
  border-top: 1px solid var(--bs-border-color);
  padding: 16px 24px;
  gap: 10px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .page-container {
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/Order.vue